import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import { Nav, Tab, Row, Col, Container, Form } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-datetime/css/react-datetime.css";
import Accordion from "react-bootstrap/Accordion";
import { useParams, useHistory } from "react-router-dom";
import useAxiosFile from "../../actions/useaxios";
import config from "../../actions/config";
import {
  DecryptData,
  EncryptData,
  ImgEmpty,
  MinuteHourFormat,
  NumANdDotOnly,
  NumberOnly,
  isEmpty,
} from "../../actions/common";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import {
  GetLatLngBasedOnAddress,
  GetAddressBasedOnLatLng,
} from "../Map/geocode";

// import deletSvg from "";

function Settings() {
  const initdata = {
    FirstName: "",
    LastName: "",
    EmailId: "",
    Mobile: "",
    DateofBirth: "",
    Gender: "",
    Profile: "",
  };

  const { token, payload } = useSelector((state) => state.admin_panel.User);
  const { toggle } = useSelector((state) => state.admin_panel.User);
  const location = useLocation();
  const { pathname, search, state } = useLocation();

  const [formValue, setFormValue] = useState({});
  const [Error, SetError] = useState({});
  const [activeTab, setActiveTab] = useState("profile");
  const [id, Setid] = useState("");
  const [Disable, SetDisable] = useState(false);

  console.log("dfgdformValue", formValue);

  const navigate = useNavigate();

  const axiosFile = useAxiosFile();

  const OnChange = (e, ids) => {
    SetError({});
    if (ids) {
      return setFormValue({ ...formValue, [ids]: e });
    }
    let { id, value } = e?.target;
    if (id == "distance") {
      return setFormValue({ ...formValue, [id]: NumANdDotOnly(value) });
    } else {
      setFormValue({ ...formValue, [id]: value });
    }
  };

  useEffect(() => {  
    if(payload?._id){
      GetData();
    }
    
  }, [payload]);

  const GetData = async (id) => {
    let Resp = await axiosFile.AdminUpdate({
      action: "get",
      from: "admin",
      _id: payload?._id,
    });
    console.log("respppppp", Resp);
    if (Resp?.status) {
      setFormValue(Resp?.data);
    } else {
      toast.error("Invalid Datas");
      // navigate("/");
    }
  };

  const Validation = async () => {
    let error = {};
    if(isEmpty(formValue?.username)){
      error.username = "Enter User Name";
    }
    if(isEmpty(formValue?.Mobile)){
      error.Mobile = "Enter Mobile Number";
    }
    else if (!isValidPhoneNumber(formValue?.Mobile)) {
      error.Mobile = "Enter Valid Mobile Number";
    }
    if (isEmpty(formValue?.EmailId)) {
      error.EmailId = "Enter Email-Id";
    } 
    else if (!config.EMAIL.test(formValue?.EmailId)) {
      error.EmailId = "Enter Valid Email-Id";
    }
    if(ImgEmpty(formValue?.Profile)){
      error.Profile = "Choose Profile";
    }
    if(formValue?.role == 'superadmin'){
      if (isEmpty(formValue?.notifymail)) {
        error.notifymail = "Enter Email-Id";
      } else if (!config.EMAIL.test(formValue?.notifymail)) {
        error.notifymail = "Enter Valid Email-Id";
      }
      if (isEmpty(formValue?.notifymobile)) {
        error.notifymobile = "Enter Mobile Number";
      } else if (!isValidPhoneNumber(formValue?.notifymobile)) {
        error.notifymobile = "Enter Valid Mobile Number";
      }
      if (isEmpty(formValue?.distance)) {
        error.distance = "Enter Delivery Distance";
      }
    }
    return error;
  };

  const Submit = async () => {
    SetDisable(true);
    let Validate = await Validation();
    // console.log('validateeeeee',Validate)
    if (isEmpty(Validate)) {
      let senddata = formValue;
      let toastid = toast.loading("Updating");
      senddata.from = "admin";
      senddata.action = "update";
      let Resp = await axiosFile.AdminUpdate(senddata);

      if (Resp?.status) {
        toast.update(toastid, {
          type: "success",
          render:
            Resp?.msg && typeof Resp?.msg == "string"
              ? Resp?.msg
              : "Updated Succesfully",
          isLoading: false,
          autoClose: 1000,
        });
        const _id_a = localStorage.getItem("_id_a");
        const HavAccess = !isEmpty(_id_a)
          ? DecryptData(_id_a)
          : (payload?._id
            ? payload?._id
            : DecryptData(_id_a));
        axiosFile.AlreadyExits({ data: EncryptData({ _id: HavAccess }) });
      } else {
        toast.update(toastid, {
          type: "error",
          render:
            Resp?.msg && typeof Resp?.msg == "string" ? Resp?.msg : "Try Again",
          isLoading: false,
          autoClose: 1000,
        });
      }
    } else {
      SetError(Validate);
    }
    SetDisable(false);
  };

  const FileChange = (e) => {
    const { id, files } = e.target;
    if (files[0].type.includes("image")) {
      setFormValue({ ...formValue, ...{ [id]: files[0] } });
    } else {
      toast.error("Upload Images Only", 1000);
    }
  };

  return (
    <>
      <div>
        <div className="innerpages">
          <div className="orders_pages">
            <Headers />
            <div className="container custom_container px-lg-0">
              <div className="row mx-auto">
                <div className="innerpages_wid px-0">
                  <Sidebar />
                  <div
                    className={
                      toggle
                        ? "content-sec-inner right_widthset content_without_sidebar"
                        : "content-sec-inner  content_with_sidebar"
                    }
                  >
                    <section id="content-wrapper">
                      <div class="row">
                        <div className="top_title_sec">
                          <div>
                            {" "}
                            <p className="page_title">Settings</p>
                          </div>
                        </div>
                      </div>
                      {/* profile details */}
                      <div className=" mt-4">
                        {/* <div className="mdvsec_border sec_border">
                          <div className="row mdv_driverdtls_whole">
                            <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-12 col-12"></div>
                          </div>
                          <div className="mdv_drivertab jus_start">
                            <p className={"mdv_tabtext active"}>ZipCode</p>
                          </div>
                        </div> */}

                        {/* profile details */}
                        <>
                          <div className="mdv_profiledtls p-3">
                            {console.log("dsfdsasfa", formValue)}

                            <Row className=" mx-auto">
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                                className="mb-3 px-0"
                              >
                                <p className="mdv_inplabel">Enter User Name</p>
                                <input
                                  className="mdv_cmninput"
                                  type="text"
                                  id="username"
                                  placeholder=""
                                  value={formValue?.username || ""}
                                  onChange={(e) => OnChange(e)}
                                />
                                {Error && Error?.username && (
                                  <span className="error-msg">
                                    {Error.username}
                                  </span>
                                )}
                              </Col>
                            </Row>

                            <Row className=" mx-auto">
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                                className="mb-3 px-0"
                              >
                                <p className="mdv_inplabel">Enter Email-Id</p>
                                <input
                                  className="mdv_cmninput"
                                  type="text"
                                  id="EmailId"
                                  placeholder="Enter Email-Id"
                                  value={formValue?.EmailId || ""}
                                  onChange={(e) => OnChange(e)}
                                />
                                {Error && Error?.EmailId && (
                                  <span className="error-msg">
                                    {Error.EmailId}
                                  </span>
                                )}
                              </Col>
                            </Row>

                            <Row className=" mx-auto">
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                                className="mb-3 px-0"
                              >
                                <p className="mdv_inplabel">Enter Mobile Number</p>
                                <PhoneInput
                                    className="new_rephoneinp"
                                    placeholder="Enter Mobile Number"
                                    id="Mobile"
                                    onChange={(e) => OnChange(e, "Mobile")}
                                    value={formValue?.Mobile}
                                    defaultCountry="US"
                                    country="US"
                                    countries={["US", "IN"]}
                                  international // Makes the input accept only international format
                                  withCountryCallingCode // Includes country code in the input
                                  displayInitialValueAsLocalNumber // Includes country code in the input
                                  />
                                {Error && Error?.Mobile && (
                                  <span className="error-msg">
                                    {Error.Mobile}
                                  </span>
                                )}
                              </Col>
                            </Row>

                            <Row className=" mx-auto">
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                                className="mb-3 px-0"
                              >
                                <p className="mdv_inplabel">Choose Profile</p>
                                <input
                                      className="mdv_cmninput"
                                      type="file"
                                      id="Profile"
                                      placeholder=""
                                      onChange={(e) => FileChange(e)}
                                    />
                                {Error && Error?.Profile && (
                                  <span className="error-msg">
                                    {Error.Profile}
                                  </span>
                                )}
                              </Col>
                            </Row>

                            <img
                                  className="tab_dummyimg me-3 mb-2"
                                  src={
                                      (typeof formValue?.Profile == 'string' && formValue?.Profile)
                                      ? `${config.IMG_URL}/admin/Profile/${formValue?.Profile}`
                                      : (typeof formValue?.Profile !=
                                          "string" && formValue?.Profile?.name)
                                      ? URL.createObjectURL(formValue?.Profile)
                                      : require("../../assests/images/dummyimg.png")
                                  }
                                  alt="profie"
                                />

                            {
                              formValue?.role == 'superadmin'
                              ?
                              <>
                              <Row className=" mx-auto">
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                                className="mb-3 px-0"
                              >
                                <p className="mdv_inplabel">Enter Notification Email-Id</p>
                                <input
                                  className="mdv_cmninput"
                                  type="text"
                                  id="notifymail"
                                  placeholder=""
                                  value={formValue?.notifymail || ""}
                                  onChange={(e) => OnChange(e)}
                                />
                                {Error && Error?.notifymail && (
                                  <span className="error-msg">
                                    {Error.notifymail}
                                  </span>
                                )}
                              </Col>
                            </Row>

                            <Row className=" mx-auto">
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                                className="mb-3 px-0"
                              >
                                <p className="mdv_inplabel">
                                  Enter Notification Mobile number
                                </p>
                                <PhoneInput
                                  className="new_rephoneinp new_ph_inpt"
                                  placeholder="Enter Mobile number"
                                  id="notifymobile"
                                  onChange={(val) =>
                                    OnChange(val, "notifymobile")
                                  }
                                  value={
                                    formValue?.notifymobile
                                      ? formValue?.notifymobile
                                      : ""
                                  }
                                  defaultCountry="US"
                                  country="US"
                                  countries={["US", "IN"]}
                                        international // Makes the input accept only international format
                                        withCountryCallingCode // Includes country code in the input
                                        displayInitialValueAsLocalNumber // Includes country code in the input
                                />
                                {Error && Error?.notifymobile && (
                                  <span className="error-msg">
                                    {Error.notifymobile}
                                  </span>
                                )}
                              </Col>
                            </Row>
                            <Row className=" mx-auto">
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                                className="mb-3 px-0"
                              >
                                <p className="mdv_inplabel">
                                  Enter Distance in Miles
                                </p>
                                <input
                                  className="mdv_cmninput"
                                  type="text"
                                  id="distance"
                                  placeholder="e.x. 4"
                                  value={formValue?.distance || ""}
                                  onChange={(e) => OnChange(e)}
                                />
                                {Error && Error?.distance && (
                                  <span className="error-msg">
                                    {Error.distance}
                                  </span>
                                )}
                              </Col>
                            </Row>
                              </>
                              :
                              <></>
                            }
                            
                            <div className="mdv_update_dualbtn">
                              <button
                                className="blue_btn mdv_update"
                                type="button"
                                onClick={() => Submit()}
                                disabled={Disable}
                              >
                                {formValue.action == "add"
                                  ? "Submit"
                                  : "Update"}
                              </button>
                            </div>
                          </div>
                        </>
                      </div>

                      {/* end of profile details */}
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Settings;
